<template>
    <div id="resources-appointment">
        <SelectModal v-if="selectModal.open" translation-base="" :isFilter="true" :title="selectModal.title"
            :selected-id="selectModal.selectedId" :list="selectModal.data" :stopLength="selectModal.stopLength"
            :resourceLength="selectModal.resourceLength" :multiple="selectModal.multiple" @changeTab="handleChangeTab"
            @select-item="handleSelectModalClick" @close="selectModal.open = false" />
        <div class="header">
            <div class="header__top">
                <span class="header__back" @click="redirectPage('operator/menu/resources')">
                    <BackIcon />
                </span>
                <span class="header__title">{{ $t("MakeAppointment") }}</span>
            </div>
            <div class="header__tabs">
                <div :class="['tab', currentTab === 'group' ? 'active' : '']" @click="currentTab = 'group'">
                    <div>
                        <div>{{ $t("Group") }}</div>
                        <div v-if="windowWidth > 767 && groupSelected.name" class="selected__value">
                            {{ groupSelected.name }}
                        </div>
                    </div>
                </div>
                <div class="arrow__divider">
                    <ArrowIcon />
                </div>
                <div :class="['tab', currentTab === 'workcenter' ? 'active' : '']"
                    @click="groupSelected.name && (currentTab = 'workcenter')">
                    <div>
                        <div>
                            {{ windowWidth > 767 ? $t("orderView.Workcenter") : $t("Center") }}
                        </div>
                        <div v-if="windowWidth > 767 && workcenterSelected.name" class="selected__value">
                            {{ workcenterSelected.name }}
                        </div>
                    </div>
                </div>
                <div class="arrow__divider">
                    <ArrowIcon />
                </div>
                <div :class="['tab', currentTab === 'resource' ? 'active' : '']" @click="
                    groupSelected.name && workcenterSelected.name && (currentTab = 'resource')
                    ">
                    <div>
                        <div>
                            {{ windowWidth > 767 ? $t("PointResource") : $t("Point") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="body__cards">
            <div v-if="currentTab === 'group'" class="cards">
                <GroupNWorkcenterCard v-for="group in groupList" :isGroup="true" :cardInfos="group" :key="group.name"
                    @selectCard="
                        (group) => {
                            groupSelected = group;
                            currentTab = 'workcenter';
                        }
                    " />
            </div>
            <div v-if="currentTab === 'workcenter'" class="cards">
                <GroupNWorkcenterCard v-for="workcenter in workcenterList" :cardInfos="workcenter"
                    :key="workcenter.name" @selectCard="
                        (workcenter) => {
                            workcenterSelected = workcenter;
                            currentTab = 'resource';
                        }
                    " />
            </div>
            <div v-if="currentTab === 'resource'" class="cards">
                <ResourceAppointmentCard v-for="resource in resourceList" :key="resource.resourceId"
                    :resource="resource" :siteId="currentSite" @selectCard="handleSelectResourceCard"
                    @changeFavorite="handleChangeFavorite" />
            </div>
        </div>
        <div v-if="currentTab === 'resource'" class="float-bar" id="float-bar">
            <div class="close-caption">
                <div class="filter" @click="handleSelectModal('filter')">
                    {{ $t("Operator.Filter") }}
                    <span class="filters-quantity">{{ selectModal.selectedId.length || 0 }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import SelectModal from "./components/SelectModal/SelectModal.vue";
import ResourceAppointmentCard from "./components/Resources/ResourceAppointmentCard.vue";
import GroupNWorkcenterCard from "./components/Resources/GroupNWorkcenterCard.vue";

export default {
    components: {
        SelectModal,
        ResourceAppointmentCard,
        GroupNWorkcenterCard,
        BackIcon: () => import("@/assets/images/icons/back.svg"),
        ArrowIcon: () => import("@core/assets/icons/arrow-icon.svg")
    },
    data() {
        return {
            currentTab: "group",
            filters: [],
            selectModal: {
                selectedId: [],
                open: false,
                multiple: false,
                title: "",
                data: []
            },
            workcenterSelected: {},
            groupSelected: {},
            resourcesFilterList: [],
            statusList: [],
            resourceList: [],
            groupList: [],
            workcenterList: [],
            filteredStatus: [],
            filteredResource: [],
            currentSite: this.$cookies.get("userInfo").currentSite
        };
    },
    mounted() {
        this.getGroupList().then(() => {
            this.restoreStateFromQuery();
        });
    },
    methods: {
        ...mapMutations("app", ["UPDATE_FLAG_SHOW_OVERLAY"]),
        restoreStateFromQuery() {
            const { groupId, workcenterId } = this.$route.query;

            if (groupId) {
                const groupIdNum = parseInt(groupId);
                const group = this.groupList.find(g => g.id === groupIdNum);

                if (group) {
                    this.groupSelected = group;
                    this.currentTab = 'workcenter';

                    this.getWorkcenterList().then(() => {
                        if (workcenterId) {
                            const workcenterIdNum = parseInt(workcenterId);
                            const workcenter = this.workcenterList.find(w => w.id === workcenterIdNum);

                            if (workcenter) {
                                this.workcenterSelected = workcenter;
                                this.currentTab = 'resource';
                            }
                        }
                    });
                }
            }
        },
        updateQueryParams() {
            const query = {};

            if (this.groupSelected.id) {
                query.groupId = this.groupSelected.id;
            }

            if (this.workcenterSelected.id) {
                query.workcenterId = this.workcenterSelected.id;
            }

            this.$router.replace({
                query: Object.keys(query).length > 0 ? query : {}
            }).catch(() => { });
        },
        redirectPage(route) {
            const prefix = localStorage.getItem("prefix") || this.$route.params.prefix;

            if (typeof route === "string") {
                this.$router.push({ path: `/${prefix}/${route}` });
            } else if (typeof route === "object" && route !== null) {
                const routerConfig = {
                    name: route.name,
                    params: { ...(route.params || {}), prefix },
                    query: route.query || {}
                };
                this.$router.push(routerConfig);
            }
        },
        handleSelectModal(type) {
            if (type === "filter") {
                const uniqueResources = this.getUniqueResourcesFromList();
                this.selectModal = {
                    ...this.selectModal,
                    open: !this.selectModal.open,
                    multiple: true,
                    title: "Operator.Filter",
                    data: uniqueResources,
                    stopLength: this.statusList.length,
                    resourceLength: uniqueResources.length
                };
            }
        },
        getUniqueResourcesFromList() {
            const resourceMap = new Map();
            this.resourceList.forEach((resource) => {
                if (!resourceMap.has(resource.resourceId)) {
                    resourceMap.set(resource.resourceId, {
                        id: resource.resourceId,
                        name: resource.resourceName,
                        type: "resource"
                    });
                }
            });
            return Array.from(resourceMap.values());
        },
        handleSelectResourceCard(resource) {
            if (resource && (resource.isExtrusionFlow || resource.IsExtrusionFlow)) {
                this.$bvToast?.toast(
                    "Recurso de Extrusão: Apontamento disponível exclusivamente no menu Extrusão e Fornos.",
                    {
                        title: "Fluxo de Extrusão",
                        variant: "warning",
                        solid: true
                    }
                );
                return;
            }

            const query = {};

            if (this.groupSelected.id) {
                query.groupId = this.groupSelected.id;
            }

            if (this.workcenterSelected.id) {
                query.workcenterId = this.workcenterSelected.id;
            }

            this.redirectPage({
                name: "operator-point-resource",
                params: {
                    order_id: resource.orderId,
                    resource_id: resource.resourceId,
                    material_id: resource.materialId,
                    max_orders: resource.maxOrders,
                    current_order: 1
                },
                query: query
            });
        },
        handleChangeFavorite(resourceId) {
            this.UPDATE_FLAG_SHOW_OVERLAY(true);
            this.$http2
                .post(`/api/mysfc/resource/${resourceId}/favorite?siteId=${this.currentSite}`)
                .then(() => {
                    this.getResourceList();
                });
        },
        handleChangeTab(value) {
            if (value === "stops") {
                const sortedStops = [...this.statusList].sort((a, b) =>
                    String(a.name ?? a.text ?? "").localeCompare(
                        String(b.name ?? b.text ?? ""),
                        "pt",
                        { sensitivity: "base" }
                    )
                );
                this.selectModal = {
                    ...this.selectModal,
                    data: sortedStops
                };
            }

            if (value === "resources") {
                const uniqueResources = this.getUniqueResourcesFromList();
                this.selectModal = {
                    ...this.selectModal,
                    data: uniqueResources
                };
            }
        },
        handleSelectModalClick(value) {
            this.selectModal.selectedId = value.items;
            this.filteredStatus = value.itemsWithType
                .filter((e) => !e.type)
                .map((e) => e.id);
            this.filteredResource = value.itemsWithType
                .filter((e) => e.type === "resource")
                .map((e) => e.id);
            this.selectModal.open = false;
            this.getResourceList();
        },
        getGroupList() {
            this.UPDATE_FLAG_SHOW_OVERLAY(true);
            return this.$http2.get(`/api/mysfc/operator/groups/${this.currentSite}`).then((res) => {
                this.groupList = res.data.data;
                this.UPDATE_FLAG_SHOW_OVERLAY(false);
                return res;
            });
        },
        getWorkcenterList() {
            if (!this.groupSelected.id) return Promise.resolve();

            this.UPDATE_FLAG_SHOW_OVERLAY(true);
            return this.$http2
                .get(`/api/mysfc/operator/workcenters/${this.groupSelected.id}`)
                .then((res) => {
                    this.workcenterList = res.data.data;
                    this.UPDATE_FLAG_SHOW_OVERLAY(false);
                    return res;
                });
        },
        async getResourceList() {
            this.UPDATE_FLAG_SHOW_OVERLAY(true);
            await this.getContext();
            await this.$http2
                .get(
                    `/api/mysfc/operator/resources/${this.workcenterSelected.id}?ResourceId=${this.filteredResource}&StatusIds=${this.filteredStatus}`
                )
                .then(async (res) => {
                    this.resourceList = res.data;

                    // if (this.resourceList.length > 0) {
                    //     const resourceIds = this.resourceList.map((r) => r.resourceId).join(",");
                    //     await this.$http2
                    //         .get(
                    //             `/api/oee/calculate?ResourcesIds=${resourceIds}&SiteId=${this.currentSite}`
                    //         )
                    //         .then((oeeRes) => {
                    //             const oeeByResource = oeeRes.data.data.oeeByResource;
                    //             this.resourceList = this.resourceList.map((resource) => {
                    //                 const oee = oeeByResource.find(
                    //                     (item) => item.resourceId === resource.resourceId
                    //                 );
                    //                 if (oee) {
                    //                     return {
                    //                         ...resource,
                    //                         perf: oee.performanceComponent * 100
                    //                     };
                    //                 }
                    //                 return resource;
                    //             });
                    //         })
                    //         .catch((err) => console.error(err));
                    // }

                    this.UPDATE_FLAG_SHOW_OVERLAY(false);
                });
        },
        async getContext() {
            await this.$http2
                .get(`/api/mysfc/operation-progress/context?siteId=${this.currentSite}`)
                .then((res) => {
                    this.statusList = res.data.data.status;
                    this.resourcesFilterList = res.data.data.resources;
                });
        }
    },
    computed: {
        ...mapGetters("app", ["windowWidth"])
    },
    watch: {
        groupSelected(newVal) {
            if (newVal && newVal.id) {
                this.updateQueryParams();
                this.getWorkcenterList();
            }
        },
        workcenterSelected(newVal) {
            if (newVal && newVal.id) {
                this.updateQueryParams();
                this.getResourceList();
            }
        }
    }
};
</script>

<style lang="scss">
.app-content-operator:has(#resources-appointment) {
    padding: 0 !important;
}

#resources-appointment {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .header {
        width: 100%;
        background: #fff;

        .header__top {
            display: flex;
            align-items: center;
            gap: 16px;
            padding: 15.5px 29px;
            color: #4c4541;
            font-size: 22px;
            font-weight: 600;
            line-height: 30px;
            border-top: 1px solid #cfc4be;
            border-bottom: 1px solid #cfc4be;

            .header__back {
                display: flex;
                cursor: pointer;
            }
        }

        .header__tabs {
            display: flex;
            justify-content: center;

            .arrow__divider {
                display: flex;
                align-items: center;
                justify-content: center;
                max-width: 24px;
                width: 100%;

                svg {
                    display: flex;
                    width: 12px;
                    height: 12px;
                    fill: #998f8a;
                }
            }

            .tab {
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                color: #998f8a;
                font-size: 18px;
                font-weight: 600;
                line-height: 26px;
                cursor: pointer;
                width: 100%;
                padding: 12px 24px;
                min-height: 76px;

                .selected__value {
                    color: #4c4541;
                    text-align: center;
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 26px;
                }

                &.active {
                    color: #974900;
                    border-color: #a35205;
                    box-shadow: 0px -4px 0px 0px #974900 inset;
                }
            }
        }
    }

    .float-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 0 8px;
        background: #ffffff;
        border: 1px solid #cfc4be;
        border-radius: 6px;
        box-shadow: 0px 4px 24px 0px rgba(58, 46, 38, 0.1);
        position: fixed;
        bottom: 20px;
        z-index: 10;
        font-size: 12px;
        outline: none;
        width: 100%;
        max-width: fit-content;

        .close-caption {
            display: flex;
            align-items: stretch;
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #4c4541;
            width: 100%;

            .filter {
                cursor: pointer;
                display: flex;
                gap: 12px;
                color: #974900;
                font-size: 17px;
                font-weight: 600;
                line-height: 20px;
                letter-spacing: 0.213px;
                padding: 13px 28px;

                .filters-quantity {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    color: #fff;
                    width: 18px;
                    height: 18px;
                    gap: 10px;
                    border-radius: 20px;
                    background: #974900;
                    font-size: 10px;
                    font-weight: 600;
                    line-height: 14px;
                }

                &:hover {
                    background-color: #ffede2;
                }

                &:active {
                    background-color: #ffdbc4;
                }
            }
        }
    }

    .body__cards {
        width: 100%;
        display: flex;

        .cards {
            display: flex;
            gap: 16px;
            flex-wrap: wrap;
            flex: 1;
            padding: 24px 29px;
            background: transparent;

            .resource-appoitment-card,
            .group-workcenter-card {
                flex: 1;
            }

            .group-workcenter-card {
                min-width: 375px;
                max-width: 375px;
            }
        }
    }
}

@media (max-width: 834px) {
    #resources-appointment {
        .body__cards {
            .cards {
                padding: 36px 29px;

                .resource-appoitment-card,
                .group-workcenter-card {
                    min-width: 347px;
                    max-width: 50%;
                }
            }
        }
    }
}

@media (max-width: 767px) {
    #resources-appointment {
        padding-top: 49px;

        .body__cards {
            .cards {
                padding: 36px 29px;

                .resource-appoitment-card,
                .group-workcenter-card {
                    min-width: 347px;
                    max-width: 100%;
                }
            }
        }
    }
}

@media (max-width: 480px) {
    #resources-appointment {
        .header {
            .header__top {
                font-size: 14px;
                line-height: 20px;
                padding: 19px 16px;

                .header__back {
                    svg {
                        width: 12px;
                        height: 12px;
                    }
                }
            }

            .header__tabs {
                .arrow__divider {
                    max-width: 16px;
                }

                .tab {
                    padding: 12px 16px;
                    min-height: 40px;
                    font-size: 12px;
                    line-height: 16px;
                }
            }
        }

        .float-bar {
            max-width: fit-content;

            .close-caption {
                display: flex;
                align-items: stretch;
                font-weight: 600;
                font-size: 14px;
                line-height: 20px;
                color: #4c4541;
                width: 100%;

                .filter {
                    font-size: 12px;
                    line-height: 20px;
                    letter-spacing: 0.15px;
                    padding: 4px 14px;

                    .filters-quantity {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        text-align: center;
                        color: #fff;
                        width: 18px;
                        height: 18px;
                        gap: 10px;
                        border-radius: 20px;
                        background: #974900;
                        font-size: 10px;
                        font-weight: 600;
                        line-height: 14px;
                    }
                }
            }
        }

        .body__cards {
            .cards {
                padding: 18px 16px;

                .resource-appoitment-card,
                .group-workcenter-card {
                    min-width: 288px;
                    max-width: 100%;
                }
            }
        }
    }
}
</style>
